'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import React, { Suspense, useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

function Tabs(props: React.PropsWithChildren<{}>) {
  const searchParams = useSearchParams();
  const tabIndex = searchParams?.get('tab') === 'custom' ? 1 : 0;

  const router = useRouter();
  function onTabSelected(index: number) {
    const tab = index === 1 ? 'custom' : 'demo';
    router.push(`/?tab=${tab}`);
  }

  let tabs = React.Children.map(props.children, (child, index) => {
    return (
      <button
        className="lk-button"
        onClick={() => {
          if (onTabSelected) {
            onTabSelected(index);
          }
        }}
        aria-pressed={tabIndex === index}
      >
        {/* @ts-ignore */}
        {child?.props.label}
      </button>
    );
  });

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabSelect}>{tabs}</div>
      {/* @ts-ignore */}
      {props.children[tabIndex]}
    </div>
  );
}

function DemoMeetingTab(props: { label: string }) {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));
  const startMeeting = () => {
    if (e2ee) {
      router.push(`/rooms/${generateRoomId()}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/rooms/${generateRoomId()}`);
    }
  };
  return (
    <div className={styles.tabContent}>
      <p style={{ margin: 0 }}>
      <p className={styles.message}>
Oasis for those who understand wealth flows—it does not rest. 
Gold is not digestible—after it is eaten, it is transformed and returned. 
The future belongs to creators, who see value and move toward it.
If you pass, the music of this place is yours.
But first, ensure you read and confirm the disclosures below.
        </p>
      </p>
      <p style={{ marginTop: 0 }}>
        <h2 className={styles.disclosureTitle}>READ AND CONFIRM YOU UNDERSTAND</h2>
        <p className={styles.disclosureText}>
          Details below. Read carefully. Read twice. Bring your lawyer if you must. This is not for everyone.
        </p>
        <ul className={styles.disclosures}>
          <li>You must be on the path to wealth. If you do not actively create value or pursue it, this is not for you.</li>
          <li>You must be 21+. We do not allow participation below this age under any circumstances.</li>
          <li>You must be sane. We cannot verify this—it is entirely your responsibility.</li>
          <li>This is an illusion. Everything you see here is not real, even if it feels real. By proceeding, you agree this is a fantasy experience.</li>
          <li>You may experience distortion. Your reality, values, and perspective may shift. You enter fully at your own risk.</li>
          <li>Invitation only. If you were not invited, begin with the source at AGIRich: QBase.</li>
        </ul>
      </p>
      <button style={{ marginTop: '1rem' }} className="lk-button" onClick={startMeeting}>
        CLIQUE
      </button>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
          <input
            id="use-e2ee"
            type="checkbox"
            checked={e2ee}
            onChange={(ev) => setE2ee(ev.target.checked)}
          ></input>
          <label htmlFor="use-e2ee">Enable end-to-end encryption</label>
        </div>
        {e2ee && (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
            <label htmlFor="passphrase">Passphrase</label>
            <input
              id="passphrase"
              type="password"
              value={sharedPassphrase}
              onChange={(ev) => setSharedPassphrase(ev.target.value)}
            />
          </div>
        )}
      </div>


    </div>
  );
}

function CustomConnectionTab(props: { label: string }) {
  const router = useRouter();

  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase, setSharedPassphrase] = useState(randomString(64));

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target as HTMLFormElement);
    const serverUrl = formData.get('serverUrl');
    const token = formData.get('token');
    if (e2ee) {
      router.push(
        `/custom/?liveKitUrl=${serverUrl}&token=${token}#${encodePassphrase(sharedPassphrase)}`,
      );
    } else {
      router.push(`/custom/?liveKitUrl=${serverUrl}&token=${token}`);
    }
  };
  return (
    <form className={styles.tabContent} onSubmit={onSubmit}>
      <p style={{ marginTop: 0 }}>
        <h2 className={styles.disclosureTitle}>READ AND CONFIRM YOU UNDERSTAND</h2>
        <p className={styles.disclosureText}>
          Details below. Read carefully. Read twice. Bring your lawyer if you must. This is not for everyone.
        </p>
        <ul className={styles.disclosures}>
          <li>You must be on the path to wealth. If you do not actively create value or pursue it, this is not for you.</li>
          <li>You must be 21+. We do not allow participation below this age under any circumstances.</li>
          <li>You must be sane. We cannot verify this—it is entirely your responsibility.</li>
          <li>This is an illusion. Everything you see here is not real, even if it feels real. By proceeding, you agree this is a fantasy experience.</li>
          <li>You may experience distortion. Your reality, values, and perspective may shift. You enter fully at your own risk.</li>
          <li>Invitation only. If you were not invited, begin with the source at AGIRich: QBase.</li>
        </ul>
      </p>
      <textarea
        id="token"
        name="token"
        placeholder="Token"
        required
        rows={5}
        style={{ padding: '1px 2px', fontSize: 'inherit', lineHeight: 'inherit' }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
          <input
            id="use-e2ee"
            type="checkbox"
            checked={e2ee}
            onChange={(ev) => setE2ee(ev.target.checked)}
          ></input>
          <label htmlFor="use-e2ee">Enable end-to-end encryption</label>
        </div>
        {e2ee && (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
            <label htmlFor="passphrase">Passphrase</label>
            <input
              id="passphrase"
              type="password"
              value={sharedPassphrase}
              onChange={(ev) => setSharedPassphrase(ev.target.value)}
            />
          </div>
        )}
      </div>

      <hr
        style={{ width: '100%', borderColor: 'rgba(255, 255, 255, 0.15)', marginBlock: '1rem' }}
      />
      <button
        style={{ paddingInline: '1.25rem', width: '100%' }}
        className="lk-button"
        type="submit"
      >
        Connect
      </button>
    </form>
  );
}

export default function Page() {
  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <img src="/images/agi-logos/agirich-logo-30.jpg" alt="AGI Rich" width="512" height="512" />
          <h1 className={styles.title}>AGI RICH: Clique</h1>
          <h2 className={styles.disclosureTitle}>Post-Scarcity Unlocked</h2>
       
        </div>
        <Suspense fallback="Loading">
          <Tabs>
            <DemoMeetingTab label="Create" />
            <CustomConnectionTab label="Join" />
          </Tabs>
        </Suspense>
      </main>
    </>
  );
}

